import styled from 'styled-components'
import Checkbox from '@mui/material/Checkbox'

import { COLOURS } from 'resources'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
`

export const StyledCheckbox = styled(Checkbox)`
  width: 24px;
  height: 24px;
  margin-right: 10px;
  font-size: large;
  &:hover {
    background-color: transparent;
  }
`

export const Text = styled.span`
  font-size: 16px;
  line-height: 22px;
  color: ${COLOURS.black};
  text-align: left;
`
